import { render, staticRenderFns } from "./TransferDestinationPicker.vue?vue&type=template&id=1b2d1e28&scoped=true"
import script from "./TransferDestinationPicker.vue?vue&type=script&lang=js"
export * from "./TransferDestinationPicker.vue?vue&type=script&lang=js"
import style0 from "./TransferDestinationPicker.vue?vue&type=style&index=0&id=1b2d1e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d1e28",
  null
  
)

export default component.exports